export enum AdState {
  Unknown,
  AwaitingContentApproval,
  AwaitingPayment,
  AwaitingToShow,
  Active,
  Finished,
  Rejected,
  Canceled,
}

export enum AdSpot {
  AdSpotUnknown = 0,
  AdSpotVitrine = 1,
  AdSpotSearchBar = 2,
  AdSpotChannel = 3,
  AdSpotDialog = 4,
  AdSpotBot = 5,
  AdSpotMyBank = 6,
  AdSpotMarket = 7,
  AdSpotOnBoarding = 8,
  AdSpotSponsoredMessage = 9,
}

export type BusinessAdSpot = AdSpot.AdSpotOnBoarding | AdSpot.AdSpotMyBank;

export enum Platform {
  Android = 1,
  Web,
  WebAndAndroid,
}

export interface SponsoredMessageOption {
  min_channel_members: number;
  max_channel_members: number;
}

export enum targetType {
  NONE = 0,
  GENDER = 4,
}

export type ApiDate = string;
export type ApiAdRecord = {
  id: string;
  title: string;
  pic_url: string;
  description: string;
  link: string;
  link_title: string;
  owner_id: number;
  view_count: number;
  click_count: number;
  created_at: ApiDate;
  desired_start_time: ApiDate;
  start_time: ApiDate;
  finish_time: ApiDate;
  state: AdState;
  spot: AdSpot;
  platform: Platform;
  topic: number;
  rejection_reason: string;
  set_click: number;
  set_view: number;
  tag_1: number;
  tag_2: number;
  sponsored_message_options: SponsoredMessageOption;
  name: string;
  payed_price: number;
  is_instant: boolean;
  target_type?: targetType;
  target_ids?: number[];
};

export enum CampaignType {
  ViewBased,
  ClickBased,
}

export type ApiCampaignAdRecord = {
  title: string;
  pic_url: string;
  description: string;
  link: string;
  link_title: string;
  spot: AdSpot;
  type: CampaignType;
  topic: number;
  tag_1: number;
  tag_2: number;
  view_count: number;
  click_count: number;
  cost: number;
  name: string;
  ad_id: string;
  stop_value: number;
};

export enum CampaignState {
  AwaitingApproval,
  Approved,
  Active,
  Paused,
  Finished,
  Rejected,
  Canceled,
}

export type ApiCampaignData = {
  id: string;
  owner_id: number;
  state: CampaignState;
  created_at: ApiDate;
  accept_date: ApiDate;
  rejection_reason: string;
  start_time: ApiDate;
  finish_time: ApiDate;
  ads: ApiCampaignAdRecord[];
};

export enum CampaignPackageType {
  NOPACKAGE = 0,
  BASIC = 1,
  ADVANCED = 2,
  BUSINESS = 3,
  CUSTOM = 4,
}

export type CampaignPackage = {
  allowed_concurrent_campaigns: number;
  daily_view_capacity: number;
  credit_expire_days: number;
  base_credit: number;
  campaign_click_coef: number;
  campaign_view_coef: number;
  dialog_view: number;
  sponsored_view: number;
};
